import { ShipmentsKpisActionTypes } from './constants';

type ShipmentsKpisAction = { type: string, payload: {} | string };

export const shipmentsKpisApiResponseSuccess = (actionType: string, data: any): ShipmentsKpisAction => ({
    type: ShipmentsKpisActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const shipmentsKpisApiResponseError = (actionType: string, error: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const shipmentsKpisGetNoShipments = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetNoCustomers = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_CUSTOMERS_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetTotalCost = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetBaseCost = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_BASE_COST_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetAverageCost = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_COST_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetAverageShippedWeight = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetAverageBilledWeight = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetNoShipmentsByTimeframe = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetSources = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_SOURCES_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetCarriers = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetDestinations = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_DESTINATIONS_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetShippedWeights = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetBilledWeights = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetCarrierWeights = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetTotalCostByTimeframe = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST,
    payload: { query },
});

export const shipmentsKpisGetShipmentsCountByZipCode = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIPMENTS_COUNT_BY_ZIP_CODE,
    payload: { query },
});

export const shipmentsKpisGetShipFromLocations = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_SHIP_FROM_LOCATIONS,
    payload: { query },
});

export const shipmentsKpisGetAggregatedCostByService = (query: string): ShipmentKpisAction => ({
    type: ShipmentsKpisActionTypes.GET_AGGREGATED_COST_BY_SERVICE,
    payload: { query },
});
